/**
 * Direct-PDF print routes ask axios for a Blob, so a JSON error body arrives as
 * a Blob instead of an object. Reading it back keeps the backend reason in
 * `error.response.data.message` for the consuming slice; without this the UI
 * can only ever show the generic "Request failed with status code 503".
 */
const readBlobText = (data) => {
  if (typeof data.text === "function") return data.text();
  if (typeof FileReader === "function") {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.onload = () => resolve(String(reader.result || ""));
      reader.onerror = () => resolve("");
      reader.readAsText(data);
    });
  }
  return Promise.resolve("");
};

export const blobErrorMessage = async (data) => {
  if (!data || typeof data !== "object") return "";
  try {
    const text = await readBlobText(data);
    if (!text) return "";
    try {
      const parsed = JSON.parse(text);
      const message = [parsed?.message, parsed?.error?.message, parsed?.error]
        .find(value => typeof value === "string" && value.trim());
      return message ? message.trim() : "";
    } catch (_error) {
      // A non-JSON body is still more useful than the generic axios message.
    }
    return text.trim();
  } catch (_error) {
    return "";
  }
};

export const withReadablePrintError = (request) =>
  Promise.resolve(request).catch(async (error) => {
    const message = await blobErrorMessage(error && error.response && error.response.data);
    if (message) {
      if (error.response) error.response.data = { message };
      error.message = message;
    }
    return Promise.reject(error);
  });

export default { blobErrorMessage, withReadablePrintError };
